import styled from 'styled-components';
import { getPx } from '../../../helpers/common';
import { isDefined } from '../../../helpers/defined';
import { alignStyle } from '../style';
import { absoluteCenteredStyle } from '../../../tokens/centered';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../../../helpers/media-style';
import { translateY } from '../../../style/translate-y';
export const InfoWithIconsPlaceholder = styled.span`
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  box-sizing: content-box;
  ${({
  $vertical
}) => styleForBreakpoints($vertical, $vertical => $vertical ? `width: 0;` : `height: 0;`)};
  ${({
  $iconWidth,
  $iconHeight,
  $vertical
}) => styleArrayForBreakpoints([$iconWidth, $iconHeight, $vertical], ([$iconWidth, $iconHeight, $vertical]) => $vertical ? `height: ${getPx($iconHeight)};` : `width: ${getPx($iconWidth)};`)}
  ${({
  $iconTopPosition
}) => isDefined($iconTopPosition) ? translateY($iconTopPosition) : ''}
  ${alignStyle}
  & > * {
    flex-shrink: 0;
    ${absoluteCenteredStyle}
  }
`;